const VehicleFilterForm = () => {
  // 1. Grab React and hooks directly from the Core Vendor bundle
  const React = (window as any).EcommerceCore.vendors.React;
  const { useMemo } = React;

  // 2. Grab Form & Select libraries from the Core Vendor bundle
  const { useForm, Controller } = (window as any).EcommerceCore.vendors
    .ReactHookForm;
  const Select =
    (window as any).EcommerceCore.vendors.ReactSelect.default ||
    (window as any).EcommerceCore.vendors.ReactSelect;

  // 3. Grab the API hook and Icon component from the Core (Using 'any' to bypass TS strictness)
  const { useGetCategoriesQuery } = (window as any).EcommerceCore.product.api
    .taxonomies;
  const Icon = (window as any).EcommerceCore.common.components.Icon;

  // Fetch the nested category tree
  const { data: categoryTree, isLoading } = useGetCategoriesQuery();

  // Removed the <FilterFormValues> generic here to satisfy TS
  const { control, handleSubmit, watch, setValue } = useForm({
    defaultValues: { level1: null, level2: null, level3: null },
  });

  const selectedL1 = watch("level1");
  const selectedL2 = watch("level2");

  // --- Dropdown 1: Ürün/Hizmet (Root Categories) ---
  const l1Options = useMemo(() => {
    if (!categoryTree) return [];
    return categoryTree.map((cat: any) => ({ value: cat.id, label: cat.name }));
  }, [categoryTree]);

  // --- Dropdown 2: Marka (Children of L1) ---
  const l2Options = useMemo(() => {
    if (!selectedL1 || !categoryTree) return [];
    const l1Node = categoryTree.find((c: any) => c.id === selectedL1);
    if (!l1Node || !l1Node.children) return [];
    return l1Node.children.map((cat: any) => ({
      value: cat.id,
      label: cat.name,
    }));
  }, [selectedL1, categoryTree]);

  // --- Dropdown 3: Model (Children of L2) ---
  const l3Options = useMemo(() => {
    if (!selectedL2 || !selectedL1 || !categoryTree) return [];
    const l1Node = categoryTree.find((c: any) => c.id === selectedL1);
    const l2Node = l1Node?.children?.find((c: any) => c.id === selectedL2);
    if (!l2Node || !l2Node.children) return [];
    return l2Node.children.map((cat: any) => ({
      value: cat.id,
      label: cat.name,
    }));
  }, [selectedL1, selectedL2, categoryTree]);

  // --- Submit Handler: Redirect to Shop ---
  const onSubmit = (data: any) => {
    const finalCategoryId = data.level3 || data.level2 || data.level1;
    if (!finalCategoryId) return;

    const shopUrl = (window as any).commonVariables?.shopUrl || "/shop";
    window.location.href = `${shopUrl}?productCategory=${finalCategoryId}`;
  };

  // We must return React.createElement since we are bypassing standard JSX compilation imports here
  return (
    <form className="vfb-form" onSubmit={handleSubmit(onSubmit)}>
      {/* 1. ÜRÜN / HİZMET */}
      <div className="vfb-form__group">
        <label className="vfb-form__label">ÜRÜN/HİZMET</label>
        <div className="vfb-form__input-wrapper">
          <span className="vfb-form__step">1</span>
          <Controller
            name="level1"
            control={control}
            render={({ field }: any) => (
              <Select
                {...field}
                classNamePrefix="vfb-select"
                options={l1Options}
                isLoading={isLoading}
                placeholder="Ürün/Hizmet Seçiniz"
                isSearchable={false}
                value={
                  l1Options.find((opt: any) => opt.value === field.value) ||
                  null
                }
                onChange={(option: any) => {
                  field.onChange(option?.value);
                  setValue("level2", null);
                  setValue("level3", null);
                }}
              />
            )}
          />
        </div>
      </div>

      {/* 2. MARKA */}
      <div className="vfb-form__group">
        <label className="vfb-form__label">MARKA</label>
        <div className="vfb-form__input-wrapper">
          <span className="vfb-form__step">2</span>
          <Controller
            name="level2"
            control={control}
            render={({ field }: any) => (
              <Select
                {...field}
                classNamePrefix="vfb-select"
                options={l2Options}
                isDisabled={!selectedL1 || l2Options.length === 0}
                placeholder="Marka Seçiniz"
                isSearchable={true}
                value={
                  l2Options.find((opt: any) => opt.value === field.value) ||
                  null
                }
                onChange={(option: any) => {
                  field.onChange(option?.value);
                  setValue("level3", null);
                }}
              />
            )}
          />
        </div>
      </div>

      {/* 3. MODEL */}
      <div className="vfb-form__group">
        <label className="vfb-form__label">MODEL</label>
        <div className="vfb-form__input-wrapper">
          <span className="vfb-form__step">3</span>
          <Controller
            name="level3"
            control={control}
            render={({ field }: any) => (
              <Select
                {...field}
                classNamePrefix="vfb-select"
                options={l3Options}
                isDisabled={!selectedL2 || l3Options.length === 0}
                placeholder="Model Seçiniz"
                isSearchable={true}
                value={
                  l3Options.find((opt: any) => opt.value === field.value) ||
                  null
                }
                onChange={(option: any) => field.onChange(option?.value)}
              />
            )}
          />
        </div>
      </div>

      {/* SUBMIT BUTTON */}
      <div className="vfb-form__group vfb-form__group--submit">
        <button
          type="submit"
          className="vfb-form__submit-btn"
          disabled={!selectedL1}
        >
          <Icon iconName="search" />
          <span>ARA</span>
        </button>
      </div>
    </form>
  );
};

export default VehicleFilterForm;
